const DOC_CONTEXT = require.context('!!raw-loader!./doc', false, /\.md$/)

const PAGE_TITLES = {
  user: {
    zh: '用户协议',
    en: 'User Agreement',
    jp: '利用規約'
  },
  privacy: {
    zh: '隐私政策',
    en: 'Privacy Policy',
    jp: 'プライバシーポリシー'
  }
}

export function resolveLang(la) {
  if (la === 'zh') return 'zh'
  if (la === 'jp') return 'jp'
  return 'en'
}

function getDocSuffix(lang) {
  if (lang === 'zh') return ''
  if (lang === 'jp') return '.ja'
  return '.en'
}

export function getDocFilename(type, lang) {
  return `${type}${getDocSuffix(lang)}.md`
}

function normalizeDocContent(content) {
  if (typeof content === 'string') return content
  if (content && typeof content.default === 'string') return content.default
  return ''
}

export function loadProtocolDoc(type, la) {
  const lang = resolveLang(la)
  const filename = getDocFilename(type, lang)

  try {
    return normalizeDocContent(DOC_CONTEXT(`./${filename}`))
  } catch (error) {
    const fallback = getDocFilename(type, 'en')
    return normalizeDocContent(DOC_CONTEXT(`./${fallback}`))
  }
}

export function getPageTitle(type, la) {
  const lang = resolveLang(la)
  return PAGE_TITLES[type][lang]
}
